import { useTheme } from "@mui/material";
import {
  calculation,
  cloud,
  helmert,
  remove,
  upload,
  photo,
  boxFront,
  boxBack,
  boxLeft,
  boxRight,
  boxTop,
  boxBottom,
  boxTopSameDirection,
  measurementVolume,
  measurementTwoPoint,
  measurementHorizontal,
  measurementVertical,
  measurementFlatArea,
  measurementSurface,
  documentImport,
  measurementMultiple,
  heatMap,
  IFCPlacement,
} from "../../../images/SVG/svg";
import ToolIcon from "../Icon";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const CalculationIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={calculation}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const HelmertIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={helmert}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const RemoveIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={remove}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const UploadIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={upload}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const IfcObjectIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={IFCPlacement}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const CloudIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={cloud}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const PhotoIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={photo}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxFrontIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxFront}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxBackIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxBack}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxLeftIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxLeft}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxRightIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxRight}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxTopIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxTop}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxBottomIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxBottom}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const BoxTopSameDirectionIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={boxTopSameDirection}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementVolumeIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementVolume}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementTwoPointIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementTwoPoint}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementHorizontalIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementHorizontal}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementVerticalIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementVertical}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementFlatAreaIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementFlatArea}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementSurfaceIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementSurface}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const MeasurementMultipleIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={measurementMultiple}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const DocumentImportIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={documentImport}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};

export const HeatMapIcon = (props: Props) => {
  const theme = useTheme();
  return (
    <ToolIcon
      imagePath={heatMap}
      color={props.color ? props.color : theme.palette.base.contrast}
      width={props.width}
      height={props.height}
    />
  );
};